import { useViewerStore } from "store/viewer.store"
import { useMessage } from "hooks/message.hook"
import ViewerNavigationService from "services/viewerNavigation.service"
import type { TAnnotationData } from "types/aiAgent.type"

export const useViewerNavigation = () => {
	const { setNavigating } = useViewerStore()
	const { error: showError } = useMessage()

	// Function to navigate to a specific page in the PDF
	const navigateToPage = async (pageNumber: string, quotation: string | undefined) => {
		setNavigating(true)
		try {
			const result = ViewerNavigationService.navigateToPage(pageNumber, quotation)
			if (!result.success && result.error) {
				showError(result.error)
			}
		} finally {
			setNavigating(false)
		}
	}

	// Function to navigate to a specific paragraph in the PDF
	const navigateToParagraph = async (annotationData: TAnnotationData) => {
		setNavigating(true)
		try {
			const result = ViewerNavigationService.navigateToParagraph(annotationData)
			if (!result.success && result.error) {
				showError(result.error)
			}
		} finally {
			setNavigating(false)
		}
	}

	return {
		navigateToPage,
		navigateToParagraph,
	}
}
